import * as actions from '../../redux/actions';

import AboutUsServiceMain from '../../assets/expresonorte/about-us/AboutUs-Service-Main.jpg';
import CommonService from '../../../../services/commonService';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export const AboutUs1 = props => {
  const createMarkup = () => {
    return { __html: props.aboutUsBody };
  };
  const operator = CommonService.getLocal('op');

  return (
    <React.Fragment>
      <div className="themes-about-us-1 mt10">
        <div
          className="about-us-main-container  mt10 mb10 "
          style={
            operator.operator_name === 'expressonorte'
              ? { display: 'grid', gridTemplateColumns: '1fr 1fr' }
              : {}
          }
        >
          <div
            className="left-side"
            style={
              operator.operator_name === 'expressonorte' ? { order: 2, paddingLeft: '15px' } : {}
            }
          >
            <div className="font10 less-bold-text mb5">{props.smallHeading}</div>
            <div className="font13 bold-text mb15 black-text-color capitalize">
              {props.boldHeading}
            </div>

            {operator.operator_name === 'expressonorte' ? (
              <div
                style={{ paddingRight: 20, textAlign: 'justify' }}
                className="font12 normal-text pr10 lh-1-3"
              >
                Empresa con más de <span className="bold-text">40 años de vida</span> , orientada al{' '}
                <span className="bold-text">
                  transporte de pasajeros y servicio de carga. Buses Expreso Norte
                </span>{' '}
                es parte del Holding Transporte Expreso Norte A.C. Ltda., empresa de amplia
                experiencia en el transporte de carga, pasajeros y encomiendas, con{' '}
                <span className="bold-text">cobertura en todo el norte de Chile.</span>
                <br></br>
                <br></br>
                Su moderna flota se encuentra dotada de los servicios necesarios para hacer del
                viaje una jornada de descanso, asegurando{' '}
                <span className="bold-text">altos estándares de calidad</span>. Apoyado por un
                excelente equipo humano, <span className="bold-text">Buses Expreso Norte</span>{' '}
                trabaja en la perfección orientada a la calidad de servicio logrando excelencia en
                la atención, conducción segura, puntualidad y en general un servicio de traslado
                eficiente y oportuno.
                <br></br>
                <br></br>
                Con <span className="bold-text">Agencias de Ventas propias</span> e interconectadas
                en línea con las distintas ciudades,{' '}
                <span className="bold-text">Expreso Norte</span> logra generar presencia y
                asistencia en el Norte de Chile.
                <br></br>
                <br></br>
                <span className="bold-text">Expreso Norte</span> se ha consolidado como una empresa
                ágil y dinámica, logrando implementar{' '}
                <span className="bold-text">métodos de control en tránsito y horarios</span>,
                ciñéndose a las normativas legales vigentes. Con el convencimiento y la experiencia
                del desarrollo de proyectos enmarcados en políticas de seguridad y control,{' '}
                <span className="bold-text">
                  Expreso Norte pone a su disposición sus servicios de transporte de pasajeros,
                  servicios especiales, convenios, cargas y encomiendas
                </span>
                .<br></br>
              </div>
            ) : (
              <div
                style={{ paddingRight: 20, textAlign: 'justify' }}
                className="font12 normal-text pr10 lh-1-3"
              >
                Tenemos <span style={{ fontWeight: 'bold' }}>más de 37 años de servicio</span>{' '}
                dedicados al transporte terrestre de pasajeros y contamos con una amplia variedad de
                vehículos comprometida en <span style={{ fontWeight: 'bold' }}>mover a Chile.</span>{' '}
                Cumplimos con todo tipo de recorrido, en los que destacan los viajes interurbanos,
                específicamente en el cono sur y sus localidades, entregando comodidad y
                puntualidad.
                <br></br>
                <br></br>
                Además trabajamos con una{' '}
                <span style={{ fontWeight: 'bold' }}> flota de buses urbanos, </span> que ofrece un
                servicio integral a todo tipo de empresas, colegios y universidades, siempre a
                disposición para los requerimientos de{' '}
                <span style={{ fontWeight: 'bold' }}>servicios fijos y especiales.</span> <br></br>
                <br></br>
                En la actualidad,{' '}
                <span style={{ fontWeight: 'bold' }}>Transportes La Pirámide Ltda.</span> es una
                empresa posicionada con los mejores precios del rubro en el mercado, reconocidos por
                la responsabilidad debido a nuestra vasta experiencia en el área, contando con{' '}
                <span style={{ fontWeight: 'bold' }}>
                  capacitaciones y las certificaciones correspondientes.
                </span>
              </div>
            )}
            {/* <div style={{paddingRight:20}} className=' lh-1-3 font10 ' dangerouslySetInnerHTML={createMarkup()} /> */}
          </div>
          <div
            className="right-side"
            style={
              operator.operator_name === 'expressonorte' ? { order: 1, marginTop: '20px' } : {}
            }
          >
            {/* /theme1/bus-about-us.jpg */}
            <img
              src={
                operator.operator_name === 'expressonorte'
                  ? AboutUsServiceMain
                  : '/theme1/bus-about-us.jpg'
              }
              alt="About Us"
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutUs1);



// WEBPACK FOOTER //
// ./src/features/themes/common/about-us/AboutUs1.js